import React, {
  createContext,
  useState,
  ReactNode,
  useContext,
  useCallback,
} from "react";
import {
  ActivityResponseModel,
  ApproveRejectPayload,
  ApproverTimesheetPayload,
  approverTimesheetResponseData,
  CreateUpdateTimeSheetPayload,
  DiscrepancyResponse,
  getTimeheetdetailResponseModel,
  getTimesheetResponsePayload,
  GetutilisationResponse,
  leaveReportPayload,
  LeaveReportResponse,
  MovementRegisterResponse,
  myTimesheetListResponse,
  MyTimesheetStatusResponse,
  ReportPayload,
  ReportResponseList,
  timesheetHistoryResponse,
  utilisationPayload,
} from "../model/timesheet";
import useTimeSheetApi from "../api/timesheet";
import { getCookieData, getUserIdTokenForIonTime } from "../helper/api";
import { useNavigate } from "react-router-dom";
interface ReportTimesheetContextType {
  activity: ActivityResponseModel[] | null;
  setProjectActivity: (item: ActivityResponseModel[] | null) => void;
  timesheetdetail: getTimeheetdetailResponseModel | null;
  setTimesheetDetails: (item: getTimeheetdetailResponseModel | null) => void;
  timesheetList: myTimesheetListResponse | null;
  setTimesheetList: (item: myTimesheetListResponse | null) => void;
  timesheetReportList: myTimesheetListResponse | null;
  setReportTimesheetList: (item: myTimesheetListResponse | null) => void;
  timesheetHistory: timesheetHistoryResponse | null;
  setTimesheetHistory: (item: timesheetHistoryResponse | null) => void;
  approverTimesheetList: approverTimesheetResponseData | null;
  setApproverTimesheetList: (
    item: approverTimesheetResponseData | null
  ) => void;
  getActivities: () => void;
  getTimesheetStatusList: (item: MyTimesheetStatusResponse) => void;
  getReportTimesheetStatusList: (item: MyTimesheetStatusResponse) => void;
  getTimesheetAllData: (item: getTimesheetResponsePayload) => void;
  getTimesheetData: (item: getTimesheetResponsePayload) => void;
  createTimeSheet: (item: CreateUpdateTimeSheetPayload[]) => void;
  approve_reject_timesheet: (item: ApproveRejectPayload) => void;
  getApproverTimesheetDataList: (item: ApproverTimesheetPayload) => void;
  reportList: ReportResponseList | null;
  getTimesheetReportList: (item: ReportPayload) => void;
  LeaveReportList: LeaveReportResponse[] | null;
  setLeaveReportList: (item: LeaveReportResponse[] | null) => void;
  getLeaveReportList: (item: leaveReportPayload) => void;
  DiscrepancyReportList: DiscrepancyResponse[] | null;
  setDiscrepancyReportList: (item: DiscrepancyResponse[]) => void;
  getDiscrepancyReportList: (item: leaveReportPayload) => void;
  MovementRegisterReportList: MovementRegisterResponse[] | null;
  setMovementRegisterReportList: (item: MovementRegisterResponse[]) => void;
  getMovementRegisterReportList: (item: leaveReportPayload) => void;
  utilisationReportList: GetutilisationResponse[] | null;
  getUtilisationReportList: (item: utilisationPayload) => void;
  setUtilisationReportList: (item: GetutilisationResponse[] | null) => void;
}

const defaultReportTimesheetContext: ReportTimesheetContextType = {
  activity: null,
  setProjectActivity: () => {},
  timesheetdetail: null,
  setTimesheetDetails: () => {},
  timesheetList: null,
  setTimesheetList: () => {},
  timesheetReportList: null,
  setReportTimesheetList: () => {},
  timesheetHistory: null,
  setTimesheetHistory: () => {},
  approverTimesheetList: null,
  setApproverTimesheetList: () => {},
  getActivities: () => {},
  getTimesheetData: () => {},
  createTimeSheet: () => {},
  getTimesheetStatusList: () => {},
  getReportTimesheetStatusList: () => {},
  approve_reject_timesheet: () => {},
  getTimesheetAllData: () => {},
  getApproverTimesheetDataList: () => {},
  reportList: null,
  getTimesheetReportList: () => {},
  LeaveReportList: null,
  setLeaveReportList: () => {},
  getLeaveReportList: () => {},
  DiscrepancyReportList: null,
  setDiscrepancyReportList: () => {},
  getDiscrepancyReportList: () => {},
  MovementRegisterReportList: null,
  setMovementRegisterReportList: () => {},
  getMovementRegisterReportList: () => {},
  utilisationReportList: null,
  getUtilisationReportList: () => {},
  setUtilisationReportList: () => {},
};

const ReportTimesheetContext = createContext<ReportTimesheetContextType>(
  defaultReportTimesheetContext
);

export const ReportTimesheetProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();

  const query = getCookieData("timesheetsReport");
  const cookeei = query ? JSON.parse(query) : null;
  const date = cookeei && cookeei?.id ? cookeei?.id.split("-") : null;
  const [LeaveReportList, setLeaveReportList] = useState<
    LeaveReportResponse[] | null
  >(null);
  const [utilisationReportList, setUtilisationReportList] = useState<
    GetutilisationResponse[] | null
  >(null);

  const [MovementRegisterReportList, setMovementRegisterReportList] = useState<
    MovementRegisterResponse[] | null
  >(null);
  const [DiscrepancyReportList, setDiscrepancyReportList] = useState<
    DiscrepancyResponse[] | null
  >(null);
  const [timesheetList, setTimesheetList] =
    useState<myTimesheetListResponse | null>(null);
  const [timesheetReportList, setReportTimesheetList] =
    useState<myTimesheetListResponse | null>(null);
  const [timesheetdetail, setTimesheetDetails] =
    useState<getTimeheetdetailResponseModel | null>(null);
  const [timesheetHistory, setTimesheetHistory] =
    useState<timesheetHistoryResponse | null>(null);
  const [activity, setProjectActivity] = useState<
    ActivityResponseModel[] | null
  >(null);
  const [reportList, setReportList] = useState<ReportResponseList | null>(null);
  const [approverTimesheetList, setApproverTimesheetList] =
    useState<approverTimesheetResponseData | null>(null);

  const getUserId = getUserIdTokenForIonTime();
  const {
    fetchProjectActivities,
    fetchGetTimesheet,
    createReport,
    fetchTimesheetList,
    approveRejectReport,
    fetchGetPromiseTimesheet,
    fetchtimesheetListFronApprover,
    fetchtimesheetReportList,
    fetchLeaveReportList,
    fetchMovementRegisterReportList,
    fetchDiscrepancyReportList,
    fetchUtilisationReport,
  } = useTimeSheetApi();

  const getActivities = useCallback(async () => {
    try {
      const responseData = await fetchProjectActivities(Number(getUserId));
      setProjectActivity(responseData);
    } catch (error) {
      // setError(error.message);
    }
  }, [fetchProjectActivities]);

  const getDiscrepancyReportList = useCallback(
    async (payload: leaveReportPayload) => {
      try {
        const responseData = await fetchDiscrepancyReportList(payload);
        setDiscrepancyReportList(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchDiscrepancyReportList]
  );

  const getMovementRegisterReportList = useCallback(
    async (payload: leaveReportPayload) => {
      try {
        const responseData = await fetchMovementRegisterReportList(payload);
        setMovementRegisterReportList(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchMovementRegisterReportList]
  );

  const getLeaveReportList = useCallback(
    async (payload: leaveReportPayload) => {
      try {
        const responseData = await fetchLeaveReportList(payload);
        setLeaveReportList(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchLeaveReportList]
  );

  const getUtilisationReportList = useCallback(
    async (payload: utilisationPayload) => {
      try {
        const responseData = await fetchUtilisationReport(payload);
        setUtilisationReportList(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchUtilisationReport]
  );

  const getTimesheetStatusList = useCallback(
    async (payload: MyTimesheetStatusResponse) => {
      try {
        const responseData = await fetchTimesheetList(payload);
        setTimesheetList(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchTimesheetList, setTimesheetList]
  );

  const getReportTimesheetStatusList = useCallback(
    async (payload: MyTimesheetStatusResponse) => {
      try {
        const responseData = await fetchTimesheetList(payload);
        setReportTimesheetList(responseData);
        return responseData;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchTimesheetList, setReportTimesheetList]
  );

  const getTimesheetAllData = useCallback(
    async (timesheetPayload: getTimesheetResponsePayload) => {
      try {
        const response = await fetchGetPromiseTimesheet(timesheetPayload);
        if (response) {
          setProjectActivity(response.activities_data);
          setTimesheetDetails(response ?? null);
          setTimesheetHistory(response.report_status_data ?? null);
          return response as getTimeheetdetailResponseModel;
        }
        return null;
      } catch (error) {
        // setError(error.message);
        return null; // Return null in case of error
      }
    },
    [fetchGetPromiseTimesheet]
  );

  const getTimesheetData = useCallback(
    async (timesheetPayload: getTimesheetResponsePayload) => {
      try {
        const timesheetDataResponse = await fetchGetTimesheet(timesheetPayload);
        setTimesheetDetails(timesheetDataResponse ?? null);
        return timesheetDataResponse;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetTimesheet]
  );

  const getApproverTimesheetDataList = useCallback(
    async (timesheetPayload: ApproverTimesheetPayload) => {
      try {
        const timesheetDataResponse = await fetchtimesheetListFronApprover(
          timesheetPayload
        );
        setApproverTimesheetList(timesheetDataResponse ?? null);
        return timesheetDataResponse;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchGetTimesheet]
  );

  const getTimesheetReportList = useCallback(
    async (reportPayload: ReportPayload) => {
      try {
        const timesheetReportDataResponse = await fetchtimesheetReportList(
          reportPayload
        );
        setReportList(timesheetReportDataResponse ?? null);
        return timesheetReportDataResponse;
      } catch (error) {
        // setError(error.message);
      }
    },
    [fetchtimesheetReportList]
  );

  const createTimeSheet = useCallback(
    async (timesheet: CreateUpdateTimeSheetPayload[]) => {
      try {
        const result = await createReport(timesheet);
        if (result) {
          navigate(-1);
          if (date && cookeei?.role === "admin") {
            navigate(0);
            // window.close();
          }
        }
        return result;
      } catch (error) {
        // setError(error.message);
      }
    },
    [createReport, navigate]
  );

  const approve_reject_timesheet = useCallback(
    async (payload: ApproveRejectPayload) => {
      try {
        const response = await approveRejectReport(payload);

        if (response) {
          if (cookeei?.role !== "admin") {
            navigate(-1);
          }
          // if (date && cookeei?.role === "admin") {
          //   // navigate(0);
          //   // window.close();
          // }
        }

        return response;
      } catch (error) {
        // setError(error.message);
      }
    },
    [approveRejectReport, navigate]
  );

  return (
    <ReportTimesheetContext.Provider
      value={{
        activity,
        setProjectActivity,
        timesheetdetail,
        setTimesheetDetails,
        timesheetList,
        setTimesheetList,
        timesheetHistory,
        approverTimesheetList,
        setApproverTimesheetList,
        setTimesheetHistory,
        getActivities,
        getTimesheetData,
        createTimeSheet,
        getTimesheetStatusList,
        approve_reject_timesheet,
        getTimesheetAllData,
        getApproverTimesheetDataList,
        reportList,
        getTimesheetReportList,
        timesheetReportList,
        getReportTimesheetStatusList,
        setReportTimesheetList,
        LeaveReportList,
        setLeaveReportList,
        getLeaveReportList,
        DiscrepancyReportList,
        setDiscrepancyReportList,
        getDiscrepancyReportList,
        MovementRegisterReportList,
        setMovementRegisterReportList,
        getMovementRegisterReportList,
        utilisationReportList,
        getUtilisationReportList,
        setUtilisationReportList,
      }}
    >
      {children}
    </ReportTimesheetContext.Provider>
  );
};

export const useReportTimesheetContext = () =>
  useContext(ReportTimesheetContext);

export { ReportTimesheetContext };
